import { useEffect } from 'react';

const useReinitializeForm = ({ reset, formValues }) => {
	useEffect(() => {
		if (formValues) {
			reset(formValues);
		}
	}, [reset, formValues]);
};

export default useReinitializeForm;
